module.exports = __webpack_public_path__ + "img/pdf.257e5b7a.png";